import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize, registerField } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'META_BASE_SUPERVISOR_TRIMESTRE_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'META_BASE_SUPERVISOR_TRIMESTRE_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('metaBaseSupervisorTrimestreForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/metaBaseSupervisorTrimestre`);
    return {
        type: 'META_BASE_SUPERVISOR_TRIMESTRE_LISTADO',
        payload: request
    };
}

export function getListaMetaApuracao() {
    const request = axios.get(`${consts.API_URL}/metaBaseSupervisorTrimestre/apuracao`);
    return {
        type: 'META_BASE_SUPERVISOR_TRIMESTRE_APURACAO_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {

		if (!registro.id) {
	        axios.post(`${consts.API_URL}/metaBaseSupervisorTrimestre`, {
                ...registro,

				//Indicador I — Visita de Qualidade
				visita_qualidade_peso: FormatUtils.formatarValorBanco(registro.visita_qualidade_peso, 0),
				visita_qualidade_meta: FormatUtils.formatarValorBanco(registro.visita_qualidade_meta, 0),
				visita_qualidade_realizado: FormatUtils.formatarValorBanco(registro.visita_qualidade_realizado, 0),

				//Indicador II — Ajuste de Estoque
				estoque_peso: FormatUtils.formatarValorBanco(registro.estoque_peso, 0),
				estoque_meta_faixa1: FormatUtils.formatarValorBanco(registro.estoque_meta_faixa1, 2),
				estoque_meta_faixa2: FormatUtils.formatarValorBanco(registro.estoque_meta_faixa2, 2),
				estoque_meta_faixa3: FormatUtils.formatarValorBanco(registro.estoque_meta_faixa3, 2),
				estoque_meta_faixa4: FormatUtils.formatarValorBanco(registro.estoque_meta_faixa4, 2),
				estoque_percentual_faixa1: FormatUtils.formatarValorBanco(registro.estoque_percentual_faixa1, 2),
				estoque_percentual_faixa2: FormatUtils.formatarValorBanco(registro.estoque_percentual_faixa2, 2),
				estoque_percentual_faixa3: FormatUtils.formatarValorBanco(registro.estoque_percentual_faixa3, 2),
				estoque_percentual_faixa4: FormatUtils.formatarValorBanco(registro.estoque_percentual_faixa4, 2),
				estoque_realizado: FormatUtils.formatarValorBanco(registro.estoque_realizado, 2),

				//Indicador III — Performance Operadores de Base
				performance_operador_peso: FormatUtils.formatarValorBanco(registro.performance_operador_peso, 0),
				performance_operador_realizado: FormatUtils.formatarValorBanco(registro.performance_operador_realizado, 2),

				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/metaBaseSupervisorTrimestre`, {
                ...registro,
				
				//Indicador I — Visita de Qualidade
				visita_qualidade_peso: FormatUtils.formatarValorBanco(registro.visita_qualidade_peso, 0),
				visita_qualidade_meta: FormatUtils.formatarValorBanco(registro.visita_qualidade_meta, 0),
				visita_qualidade_realizado: FormatUtils.formatarValorBanco(registro.visita_qualidade_realizado, 0),

				//Indicador II — Ajuste de Estoque
				estoque_peso: FormatUtils.formatarValorBanco(registro.estoque_peso, 0),
				estoque_meta_faixa1: FormatUtils.formatarValorBanco(registro.estoque_meta_faixa1, 2),
				estoque_meta_faixa2: FormatUtils.formatarValorBanco(registro.estoque_meta_faixa2, 2),
				estoque_meta_faixa3: FormatUtils.formatarValorBanco(registro.estoque_meta_faixa3, 2),
				estoque_meta_faixa4: FormatUtils.formatarValorBanco(registro.estoque_meta_faixa4, 2),
				estoque_percentual_faixa1: FormatUtils.formatarValorBanco(registro.estoque_percentual_faixa1, 2),
				estoque_percentual_faixa2: FormatUtils.formatarValorBanco(registro.estoque_percentual_faixa2, 2),
				estoque_percentual_faixa3: FormatUtils.formatarValorBanco(registro.estoque_percentual_faixa3, 2),
				estoque_percentual_faixa4: FormatUtils.formatarValorBanco(registro.estoque_percentual_faixa4, 2),
				estoque_realizado: FormatUtils.formatarValorBanco(registro.estoque_realizado, 2),

				//Indicador III — Performance Operadores de Base
				performance_operador_peso: FormatUtils.formatarValorBanco(registro.performance_operador_peso, 0),
				performance_operador_realizado: FormatUtils.formatarValorBanco(registro.performance_operador_realizado, 2),
				
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/metaBaseSupervisorTrimestre?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function processarApuracao(registro, evento) {
	return (dispatch, getState) => {
		axios.put(`${consts.API_URL}/metaBaseSupervisorTrimestre/apuracao`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaMetaApuracao());
			evento();
		}).catch(e => {
			console.log(e);
			
			setErroAPI(e);
		});
	};
}

export function getListaUsuario() {
    const request = axios.get(`${consts.API_URL}/usuario/listarSelect`);
    return {
        type: 'META_BASE_SUPERVISOR_TRIMESTRE_USUARIO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'META_BASE_SUPERVISOR_TRIMESTRE_VEICULO_SELECT_LISTADO',
        payload: request
    };
}

export function importarCustos(tabela) {
    return async (dispatch, getState) => {

		dispatch(setAguardando(true));

		let lista = [];

		let listaTipos = [];
		await axios.get(`${consts.API_URL}/custoTipo`).then(result => {
			listaTipos = result.data;
		});
		
		for (var i = 0; i < tabela.length; i++) {
			let item = tabela[i];

			let data = item[8];

			let analitica = (item[4] || '').split('-')[0] ? (item[4] || '').split('-')[0].replace('Analítica:', '').trim() : null;
			
			if (data && analitica) {

				let tipo = listaTipos.filter(tipoCusto => (tipoCusto.analiticas || []).filter(idAnalitica => idAnalitica == analitica).length)[0];
				
				data.setHours(data.getHours() + 12);

				let valor = item[19];
				if (data && valor && tipo) {
					let competencia = `${data.getFullYear()}${String(data.getMonth() + 1).padStart(2, '0')}`;

					if (!lista.filter(registro => registro.id_tipo == tipo.id && registro.competencia == competencia).length) {
						lista.push({
							id_tipo: tipo.id,
							competencia: competencia,
							valor: 0,
							id_usuario_inclusao: getState().auth.usuario.id,
							id_usuario_alteracao: getState().auth.usuario.id
						});
					}

					lista = lista.map(registro => {
						if (registro.id_tipo == tipo.id && registro.competencia == competencia) {
							return {
								...registro,
								valor: registro.valor + valor
							};
						} else {
							return registro;
						}						
					});		
				} else {
					console.log(item[4], ' = ', item[19]);
				}
			} else {
				if (item[4] && item[19]) {
					console.log(item[4], ' = ', item[19]);
				}
			}
		}

		await axios.post(`${consts.API_URL}/custoImportacaoMes`, {
			lista: lista
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaMetaApuracao());
		}).catch(e => {
			setErroAPI(e);
		});

		dispatch(setAguardando(false));

	}
}

export function imprimir(registro) {

	return (dispatch, getState) => {
		
		dispatch(setAguardando(true));

		axios.post(`${consts.API_URL}/metaBaseSupervisorTrimestre/imprimir`, {
            registro: registro,
			datahora_emissao: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual())
        }).then(resp => {
			
			const link = document.createElement('a');
			link.href = `data:application/pdf;base64,${resp.data.pdf}`;
			link.download = resp.data.filename;
			link.click();

			dispatch(setAguardando(false));
		}).catch(ex => {
			console.log(ex);
			dispatch(setAguardando(false));
		});

	}
}